var name = "Scarlet 101_1B2Pv2";
var uuid = "c80f7884-cd13-4fa1-989a-99d7287c42ee";
var pos = [
	0,
	0,
	0
];
var rot = [
	0,
	0,
	0
];
var size = [
	7.775,
	3.0475,
	9.775
];
var anchor = [
	0.5,
	0,
	0.7953964020172811
];
var color = "#f57eb6";
var alpha = 1;
var rg = true;
var type = "Apartment";
var children = [
	{
		name: "balcony",
		uuid: "bf0aa84e-2967-4846-80b7-4deb9379bf7e",
		pos: [
			0.2875,
			0.145,
			-7.775
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.9,
			0.16,
			2
		],
		anchor: [
			0,
			0,
			0
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Balcony",
		children: [
			{
				name: "floor",
				uuid: "4c9d2009-70bd-449d-9c13-07171678178a",
				pos: [
					1.95,
					0.08,
					1
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.9,
					0.16,
					2
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			}
		]
	},
	{
		name: "Bedroom Double",
		uuid: "f2a29328-fa64-4448-853d-057a6cd1be8f",
		pos: [
			-1.95,
			0.305,
			-5.5375
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			3.6
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "M4(2) Bathroom",
		uuid: "d8f92e4b-3f51-4964-91e1-12831f9ae326",
		pos: [
			-2.75,
			0.305,
			-1.2375
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			2.2,
			2.4384,
			2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fe4365",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Bathroom"
		}
	},
	{
		name: "Kitchen / Living / Dining",
		uuid: "3a05d610-7053-4da3-b27e-d8df2683387c",
		pos: [
			1.95,
			0.305,
			-1.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.6,
			2.4384,
			7.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#00a0b0",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "KitchenLivingDining",
			polygon: [
				[
					3.75,
					0.305,
					-5.3375
				],
				[
					0.15,
					0.305,
					-5.3375
				],
				[
					0.15,
					0.305,
					-2.2375
				],
				[
					0.15,
					0.305,
					-1.2375
				],
				[
					0.15,
					0.305,
					-0.0688
				],
				[
					0.15,
					0.305,
					0.9675
				],
				[
					1.845,
					0.305,
					0.9675
				],
				[
					1.845,
					0.305,
					1.8625
				],
				[
					3.75,
					0.305,
					1.8625
				],
				[
					3.75,
					0.305,
					-5.3375
				]
			]
		}
	},
	{
		name: "Storage",
		uuid: "5cf99cca-c8ff-44ba-8786-894d41addf6b",
		pos: [
			-2.75,
			0.305,
			-3.0375
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			1.21,
			2.4384,
			2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Utility",
		uuid: "6c4e44be-55fb-4f7b-9eee-cee8bb2cf828",
		pos: [
			0.95,
			0.305,
			1.4625
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			0.8,
			2.4384,
			1.6
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#c44d58",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Utility"
		}
	},
	{
		name: "Hallway",
		uuid: "b7591923-36a8-435a-83d5-6db7acf8eef1",
		pos: [
			-0.8212,
			0.305,
			-1.89
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.6675,
			2.4384,
			3.505
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway",
			polygon: [
				[
					-1.655,
					0.305,
					-0.1375
				],
				[
					-0.15,
					0.305,
					-0.1375
				],
				[
					-0.15,
					0.305,
					-1.2375
				],
				[
					0.0125,
					0.305,
					-1.2375
				],
				[
					0.0125,
					0.305,
					-2.2375
				],
				[
					-0.15,
					0.305,
					-2.2375
				],
				[
					-0.15,
					0.305,
					-3.6425
				],
				[
					-1.655,
					0.305,
					-3.6425
				],
				[
					-1.655,
					0.305,
					-2.385
				],
				[
					-1.655,
					0.305,
					-0.1375
				]
			]
		}
	},
	{
		name: "module",
		uuid: "db3f12c7-2769-454e-bd78-ee01714e59d7",
		pos: [
			-1.95,
			1.5225,
			-3.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			7.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#f57eb6",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "53c3d753-5992-4d29-836b-23a519026039",
				pos: [
					0,
					0.0725,
					-3.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "dba8b51b-0e1f-4be1-87aa-594cd5dfc6e4",
						pos: [
							0,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.76,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|12|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "f9002d53-063f-43a5-90e5-2031d5e48397",
				pos: [
					-1.8687,
					0.0725,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "8a5dc6cf-601b-4a11-a94d-90f193fd3957",
				pos: [
					-0.0688,
					0.0725,
					3.6688
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "97e39813-a59c-47e3-afdf-0197402c303a",
						pos: [
							-1.1638,
							-0.2275,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.01,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|01|UK-DIS0001",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: true
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "e51593cf-4e23-4177-8bda-9b720d5c5dfd",
				pos: [
					1.8687,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "b898464e-b4af-46a3-9d29-b28f6f0ae252",
						pos: [
							-2,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "b34756ab-f615-485f-9e32-8e88db13cdd0",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "9b32427f-531d-4f0f-aacc-f8297a1f537e",
				pos: [
					0.2475,
					0.07,
					1.8475
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					3.505,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "4270ae39-6554-4667-903e-b3c1d2dd2054",
						pos: [
							0.1525,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "d82d51a4-6880-4b4c-a342-ce655da408e7",
						pos: [
							-1.1475,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "7f40c92b-be52-4668-a787-6975d18d4431",
				pos: [
					0,
					0.07,
					0.0475
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "8e01348b-e780-4939-9585-d5b0439f0fd5",
						pos: [
							1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "a0d99d80-1967-49d9-a863-3dbe8a084bdc",
				pos: [
					-0.8,
					0.07,
					1.3525
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "beam",
				uuid: "5f6042fe-e3a1-46dd-8728-dba02f78c338",
				pos: [
					0,
					-1.4075,
					-3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "a21d3b5a-1a64-4fb3-9490-a5140696ee50",
				pos: [
					0,
					-1.4075,
					3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "14065e68-16a5-439b-8401-d4ce22e448a2",
				pos: [
					0,
					-1.372,
					-3.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "3157bc1a-bc3c-443f-919c-34696400ac4e",
				pos: [
					0,
					-1.372,
					-3.5488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "72125b4c-27fb-4073-a5d1-8590b7ea01d2",
				pos: [
					0,
					-1.372,
					3.5488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "787ebf5b-2d00-4a34-adaa-ac9e20a16205",
				pos: [
					0,
					-1.372,
					3.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "e6faf455-e510-4dfd-b6b7-7a8eb654efaa",
				pos: [
					0,
					-1.3595,
					0.805
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "bed01e86-61b9-476c-9de0-9adcd8a894e2",
				pos: [
					0,
					-1.3595,
					0.745
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "95aaed2b-d02a-4a13-8ea6-55ae08fe7797",
				pos: [
					0,
					-1.3595,
					2.105
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "db1350d3-2603-4bb6-aa5c-d34052dc486a",
				pos: [
					0,
					-1.3595,
					2.045
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "ba14992e-205f-4fa6-bc51-cc907ac807fc",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "65e2027d-935c-44c8-b3e3-b63901629377",
				pos: [
					1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "115e928c-74bf-48c9-92b9-8069a71af312",
				pos: [
					-1.875,
					0.0812,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "6f304dc4-b53b-4db5-998f-7b2d2beeed3e",
				pos: [
					-1.875,
					0.0812,
					-3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "19305c6f-0782-4516-a027-15a9a4e05287",
				pos: [
					1.875,
					0.0812,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "576ed437-9a89-4e1b-8398-3d57d2dfa805",
				pos: [
					1.875,
					0.0812,
					-3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "9299c2fe-1d2b-4d60-bd87-4b496e8a3d4a",
				pos: [
					0,
					-1.372,
					-0.6012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "2bd5d177-c867-45bd-a69b-6970afe379ea",
				pos: [
					0,
					-1.372,
					-0.8487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "9a0ed4fa-d91f-4e0a-b53b-e87bfcd8fafe",
				pos: [
					-1.875,
					0.0812,
					-0.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "42a9468a-f53f-44ba-97b1-2ce1dfca1463",
				pos: [
					1.875,
					0.0812,
					-0.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "83823326-b43d-43e2-807f-254803d44ad8",
				pos: [
					0,
					-1.3595,
					-2.035
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9996537a-aa97-4fc9-b0bf-a3750cb84588",
				pos: [
					0,
					-1.3595,
					-2.095
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "floor",
				uuid: "89aa6037-3591-46d9-984c-1fc97a1ff90b",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "ceiling",
				uuid: "2a67c636-4739-467d-a003-862997ecb502",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "41f9752a-9ef9-4e5a-8ed6-c025c51e5ce0",
		pos: [
			1.95,
			1.5238,
			-1.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.0475,
			7.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#f57eb6",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "f55cc02b-5c65-43ba-b04f-5216e87e30f3",
				pos: [
					0,
					0.0712,
					-3.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "15820cfa-5ac3-43ee-a907-a4032ccb0389",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "d917a488-802b-42bb-9aa0-f58e0228f4dd",
				pos: [
					-1.8687,
					0.0712,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "cfbe4818-9882-49a3-8a2c-8aeebb32b26a",
						pos: [
							0.0688,
							-0.227,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "f913eec7-cf46-4485-af43-d60670b25660",
				pos: [
					-0.0687,
					0.0712,
					3.6688
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "ea0ccc62-5587-4746-9c47-a8d9e722cf6f",
				pos: [
					1.8687,
					0.0712,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "21e3a530-15ab-4370-8029-f3e9638ea077",
						pos: [
							1.325,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.76,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|12|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "7dc6f459-ac15-4c48-b9e8-cb656d305e8b",
				pos: [
					-0.1525,
					0.0687,
					3.1525
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.895,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "1b6cfeae-3466-499e-abd9-3ecb675f36d3",
				pos: [
					-1,
					0.0687,
					2.7525
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					1.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "de7561a2-3242-46c9-b3ba-ae2fa8b6d5f8",
						pos: [
							0,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "00f265e7-d968-4162-a820-231fd8bc7049",
				pos: [
					0,
					-1.2613,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "95869696-c641-4129-bac8-30f7ddca6f4f",
				pos: [
					0,
					-1.4088,
					-3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "45821ba8-ab10-4a37-a301-342c087fcf2d",
				pos: [
					0,
					-1.4088,
					3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "0985a25c-0498-4e19-a82b-109716a99648",
				pos: [
					0,
					-1.3733,
					-2.6012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "58bb410a-86a4-4c9a-b9bc-ade7e09f4ddd",
				pos: [
					0,
					-1.3733,
					-2.8487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f10437c2-34e1-47af-9974-bbf275465e98",
				pos: [
					0,
					-1.3733,
					3.5488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "546e3631-9e68-4576-a346-3d4fda4df6fb",
				pos: [
					0,
					-1.3733,
					3.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d7bd9b66-1136-40f0-a4f3-d4bef3ab0d24",
				pos: [
					0,
					-1.3608,
					0.045
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "cc45ea7f-a890-4c81-a50b-04c81f73b372",
				pos: [
					0,
					-1.3608,
					-0.015
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "66272100-9e6d-4989-8ab9-37024ff48263",
				pos: [
					0,
					-1.3608,
					2.4263
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d1c391a8-592d-4cfb-a2e5-4e09e2003928",
				pos: [
					0,
					-1.3608,
					2.3663
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "50b7cd90-15d3-4862-bc13-b5fd6b4d75cd",
				pos: [
					-1.875,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "6d987bc9-7e24-46e8-9329-33e9965505df",
				pos: [
					1.875,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "fa657449-e320-4c05-86f2-20f36c5858c4",
				pos: [
					-1.875,
					0.08,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "4c618c4c-0ef0-4b93-a070-ebb7554b5896",
				pos: [
					-1.875,
					0.08,
					-2.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "38075434-ba32-43ed-a335-8dd02d2980e9",
				pos: [
					1.875,
					0.08,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "fbf97149-57fd-4281-89b7-2723121406b5",
				pos: [
					1.875,
					0.08,
					-2.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "d46501a5-9784-4e97-8d55-8f04f6f57ff1",
				pos: [
					0,
					-1.3608,
					-1.275
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "2465710d-b8ad-40e3-97a5-595860909b89",
				pos: [
					0,
					-1.3608,
					-1.335
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f4bb5a12-6ccb-4fa0-be80-e2d49d82a34b",
				pos: [
					0,
					-1.3733,
					1.5488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "1530e01f-1d7a-49a0-88e8-b091e10ed88f",
				pos: [
					0,
					-1.3733,
					1.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "9cfbc916-cdfa-420c-ba5e-c02e71fe0e2b",
				pos: [
					-1.875,
					0.08,
					1.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "9963df42-fbdf-4ba8-8d53-8d84eb99b076",
				pos: [
					1.875,
					0.08,
					1.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "8631ee0d-0d56-4e06-a494-af3ae771ab0e",
				pos: [
					0,
					-1.3608,
					-3.5925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.44,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "floor",
				uuid: "1b7c4c19-17b6-45aa-aaf9-ea2066330a8e",
				pos: [
					0,
					-1.2238,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "ceiling",
				uuid: "695452b4-5a43-4396-9dbd-a49a6d754bed",
				pos: [
					0,
					1.4463,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	}
];
var data = {
	level: -1,
	levelId: "",
	occupants: 2,
	bedrooms: 1,
	habitableRooms: 2,
	nia: 53.4,
	muscleID: "",
	category: "1B2P",
	closeCorridor: true,
	closeDirection: [
		1,
		0,
		0
	],
	closeLength: 3.875
};
var UK01_1B2P_V2 = {
	name: name,
	uuid: uuid,
	pos: pos,
	rot: rot,
	size: size,
	anchor: anchor,
	color: color,
	alpha: alpha,
	rg: rg,
	type: type,
	children: children,
	data: data
};

export { alpha, anchor, children, color, data, UK01_1B2P_V2 as default, name, pos, rg, rot, size, type, uuid };
//# sourceMappingURL=Scarlet-101-1B2Pv2.json.js.map
